import { Pipe, PipeTransform } from '@angular/core';
import { ClientLifecycleStage } from '@wdx/clmi/clmi-swagger-gen';

@Pipe({ name: 'lifecycleStageToCSSClass', standalone: false })
export class LifecycleStageToCSSClass implements PipeTransform {
    transform(lifecycleStage: ClientLifecycleStage, light?: boolean): string {
        if (!lifecycleStage) {
            return '';
        }

        return `lifecycle-stage-${lifecycleStage.toString().toLowerCase()}${
            light ? '-light' : ''
        }`;
    }
}
